import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import TextInput from '../../../../Shared/TextInput/TextInput';
import {setNumberForNuid} from '../../TransferOrganizationAccountSlice';

const NiudNumberComponent = (props) => {
  const handleInputChange = (e) => {
    const currentItem = e.nativeEvent.data;
    const regex = /^\d+$/; // Regular expression to allow only digits

    if (regex.test(currentItem) || !e.nativeEvent.data) {
      props.setNumberForNuid({value: e.target.value});
    } else return null;
  };
  return (
    <div className='niud-number-component transfer-line-sub-step borderline'>
      <div className='M_Sub_Title'>מהו המספר לניוד?</div>
      <div className=''>
        <TextInput
          error={props.data.numberForNiudForm.error}
          placeholder='מספר טלפון'
          onChange={(e) => handleInputChange(e)}
          value={props.data.numberForNiudForm.value}
          name={'niudNumber'}
          type='text'
          required='required'
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {setNumberForNuid};

export default connect(mapStateToProps, mapDispatchToProps)(NiudNumberComponent);
